import moment, { Moment } from "moment";

export default class Direito implements IDireito {
  public id!: string;
  public codigoAtivo!: string;
  public nome!: string;
  public isin!: string;
  public dataEmissao!: Moment;
  public dataVencimento!: Moment;
  public precoUnitario!: number;
  public codigoObjeto!: string;

  constructor(param: IDireito) {
    Object.assign(this, param);
  }
  public static fromJson(json: IDireitoJson) {
    return new Direito({
      ...json,
      dataEmissao: moment.tz(json.dataEmissao, "America/Sao_Paulo"),
      dataVencimento: moment.tz(json.dataVencimento, "America/Sao_Paulo"),
    });
  }
}

interface IDireito {
  id: string;
  codigoAtivo: string;
  nome: string;
  isin: string;
  dataEmissao: Moment;
  dataVencimento: Moment;
  precoUnitario: number;
  codigoObjeto: string;
}

export interface IDireitoJson
  extends Omit<IDireito, "dataEmissao" | "dataVencimento"> {
  dataEmissao: string;
  dataVencimento: string;
}
